import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatTooltipModule } from '@angular/material/tooltip'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSelectModule } from '@angular/material/select'
import { LosDiscountDialogComponent } from './components/dialogs/los-discount-dialog.component'
import { LosDiscountDialogService } from './components/dialogs/los-discount-dialog.service'
import { LosDiscountModule } from './store/los-discount/los-discount.module'
import { PermissionModule } from '@tokeet-frontend/permission'

const dialogs = [LosDiscountDialogComponent]

const services = [LosDiscountDialogService]

const modules = [
  ReactiveFormsModule,
  MatInputModule,
  MatFormFieldModule,
  MatSlideToggleModule,
  MatTooltipModule,
  MatSelectModule,
  MatDatepickerModule,
  Tv3PlatformModule,
  LosDiscountModule,
  PermissionModule,
]

@NgModule({
  imports: [CommonModule, ...modules],
  providers: [...services],
  declarations: [...dialogs],
  entryComponents: [...dialogs],
  exports: [...modules],
})
export class LosDiscountLibModule {}
